// removed by extract-text-webpack-plugin
module.exports = {"accountSettings":"_2cEv0","error":"_1e2Eu","newShippingAddressButton":"_1DP9H","newPaymentMethodButton":"_22dOD","address":"_3Lc20","paymentMethod":"_2q2qm","notificationSetting":"_2j6Dw","signOut":"_3lIx8"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettings/index.sass
// module id = 1453
// module chunks = 1